var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5612 35.5612V71.1225C15.9534 71.1225 0 55.1696 0 35.5612C0 15.9534 15.9529 0 35.5612 0C55.1691 0 71.1225 15.9529 71.1225 35.5612H35.5612ZM39.4388 39.4388H75C75 59.0466 59.0471 75 39.4388 75V39.4388Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockLevel);
export default __webpack_public_path__ + "static/media/stock-Level.d773b2c7ca094f14ef4e648219797199.svg";
export { ForwardRef as ReactComponent };